module.exports = __webpack_public_path__ + "static/media/cooling_mode.ab751ef5.png";